import React, { useEffect, useState } from 'react';
import { Button, Space, Form, message, Row, Col, Select, Alert, Modal } from 'antd';
import { OrderModel } from '@app/interfaces/order';
import { useAppDispatch, useAppSelector } from '@app/hooks/reduxHooks';
import { combineOrder, getOrders } from '@app/store/slices/orderSlice';
import { MdCancel } from 'react-icons/md';
import useDebounce from '@app/hooks/useDebounce';
import { RootState } from '@app/store/store';
import { VscCombine } from 'react-icons/vsc';

interface CombineOrderFormProps {
  open: boolean;
  record?: OrderModel;
  onClose: () => void;
}

const CombineOrderForm: React.FC<CombineOrderFormProps> = ({ open, record, onClose }) => {
  const [form] = Form.useForm();
  const [searchTermCustomer, setSearchTermCustomer] = useState<string>('');
  const debouncedSearchTermCustomer = useDebounce(searchTermCustomer, 100);
  const { data: orders = [] } = useAppSelector((state: RootState) => state.order || {});

  const dispatch = useAppDispatch();

  useEffect(() => {
    fetchOrders();
  }, [debouncedSearchTermCustomer, dispatch]);

  const fetchOrders = async () => {
    const newParams = { order_code_or_customer_name_cont: debouncedSearchTermCustomer };
    await dispatch(getOrders(newParams));
  }

  const onSearchCustomer = (value: string) => {
    setSearchTermCustomer(value)
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await dispatch(combineOrder({ orderId: Number(record?.id), formData: values })).unwrap();

      onClose();
    } catch (error: any) {
      if (error instanceof Error) {
        message.error(error.message);
      } else {
        message.error('An unknown error occurred');
      }
    }
  };

  const orderOptions = orders && orders.map((item) => ({ value: item.order_code, label: item.order_code }));
  const description = `Gộp đơn chỉ áp dụng cho trường hợp ra bill khách hàng. Bạn có chắc chắn gộp đơn với đơn hàng hiện tại ${record?.order_code}?`

  return (
    <>
      <Modal open={open} onCancel={onClose} style={{ top: 20 }} closable={true} footer={null}>
        <h3 className="mb-4">
          <span className="font-bold-weight">Gộp đơn hàng!</span>
        </h3>

        <Alert
          message="Warning"
          description={description}
          type="warning"
          banner
          closable
          className="text-warning my-3"
        />

        <Form
          form={form}
          name="form-order"
          className="order-container"
          initialValues={{
            group_code: [record?.order_code],
          }}
        >
          <Row>
            <Col span={7}>Chọn đơn hàng</Col>
            <Col span={17}>
              <Form.Item name="group_code" rules={[{ required: true, message: 'Please select a order!' }]}>
                <Select
                  allowClear
                  showSearch
                  mode="multiple"
                  placeholder="Chọn đơn hàng"
                  optionFilterProp="children"
                  onSearch={onSearchCustomer}
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  options={orderOptions}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="mt-4 text-right">
            <Col span={24}>
              <Space>
                <Button type="primary" onClick={handleSubmit}>
                  <VscCombine /> Gộp đơn
                </Button>
                <Button type="primary" danger onClick={onClose}>
                  <MdCancel /> Huỷ
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default CombineOrderForm;
